<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <div class="r">
        <el-button v-if="backRole('CM_2')" type="primary" @click="startCreate()" size="mini">前往添加会议</el-button>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId" placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="会议名称">
        <template slot-scope="scope">
          <a href="javascript:;" class="link" @click="showMeetingInfo(scope.row.id)">{{ scope.row.name }}</a>
          <el-tooltip v-if="scope.row.isHasAttas" class="item" effect="dark" content="点击查看会议资料" placement="bottom">
            <i @click="showMeetingInfo(scope.row.id)" class="el-icon-document meeting-name-icon"></i>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="会议地点" width="100px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.depName+' - '+scope.row.address" placement="bottom">
            <span>
              <i class="iconfont icon-address"></i>
              <span v-html="scope.row.address"></span>
            </span>
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column label="创建者" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="参会人员" width="160px">
        <template slot-scope="scope">
          <div v-html="getUserList(scope.row.joinUsers)"></div>
          <a href="javascript:;" @click="showMeetingInfo(scope.row.id)" v-if="scope.row.joinUsers.length>3" class="user-item">...</a>
        </template>
      </el-table-column>

      <el-table-column prop="conferenceTime" width="120px" label="会议时间">
      </el-table-column>
      <el-table-column prop="status" label="会议状态" width="70px">
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.isHasSumary" class="item" effect="dark" content="点击查看会议纪要" placement="bottom">
            <i @click="showMeetingInfo(scope.row.id)" class="iconfont icon-huiyijiyao meeting-btn-icon"></i>
          </el-tooltip>
          <div class="meeting-list-btn" v-if="scope.row.creator.name==userData.name && scope.row.status!='已取消'">
            <el-tooltip v-if="!scope.row.isHasSumary" class="item" effect="dark" content="上传/编辑会议纪要" placement="bottom">
              <i class="el-icon-upload meeting-btn-icon mbi-end" @click="setMeetingState(scope.row, 'end')"></i>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status!='进行中' && scope.row.status!='已结束'" class="item" effect="dark" content="修改会议"
              placement="bottom">
              <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit" @click="EditMeeting(scope.row)"></i>
            </el-tooltip>
            <el-tooltip v-if="scope.row.status!='进行中' && scope.row.status!='已结束'" class="item" effect="dark" content="撤销会议"
              placement="bottom">
              <i class="iconfont icon-close meeting-btn-icon mbi-remove" @click="setMeetingState(scope.row, 'cancle')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-left:-5px;" v-if="pageTotal>form.pageSize" class="list-pagination" background
      :page-size="form.pageSize" :pager-count="9" :current-page="form.page+1" layout="pager" :total="pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>

    <!-- 上传会议纪要 -->
    <meeting-sumary v-if="addMeetingStatus" :meetingSumaryId="meetingSumaryId" :projectListStatus="projectListStatus" :addMeetingStatus="addMeetingStatus" v-on:hideMeetingSumary="hideMeetingSumary()" v-on:hideProjectList="hideProjectList()" v-on:showProjectList="showProjectList()"></meeting-sumary>

    <!-- 会议资料详情 -->
    <meeting-info v-if="meetingInfoStatus" :meetingId="meetingId" :meetingInfoStatus="meetingInfoStatus" v-on:hideMeetingInfo="hideMeetingInfo()"></meeting-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import MeetingInfo from '@/components/MeetingInfo'
  import MeetingSumary from '@/components/MeetingSumary'

  import meetingMixin from '@/Mixins/meetingMixin'
  import Role from '@/Mixins/role'
  export default {
    components: {
      UserInfo,
      MeetingInfo,
      MeetingSumary,
    },
    mixins: [meetingMixin, Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: false,

        // 会议纪要
        addMeetingStatus: false,
        projectListStatus: false,
        meetingSumaryId: "",

        // 会议资料详情
        meetingInfoStatus: false,
        meetingId: "",

        form: {
          depId: '',
          page: 0,
          pageSize: 20,
        },
        // 列表
        loading: true,
        pageTotal: 0,
        listData: [],
        filterData: [],
        paginationData: [],
      }
    },
    mounted() {
      if (!this.userData) {
        return false
      }

      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.userData.secDepIds.split(",")[0] == "7") {
        // this.noSelectOrganization = false
      }

    },
    methods: {
      EditMeeting(row) {
        this.$router.push('/Meeting/Edit/' + row.id)
      },
      // 取消、结束会议
      setMeetingState(row, type) {
        switch (type) {
          case 'cancle':
            this.$confirm('此操作将会取消会议，操作结果不可逆，请你确认是否取消会议?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              ajax.post('/conference/status/edit', {
                conferenceId: row.id,
                status: "已取消"
              }, (res) => {
                this.$message.success("取消会议成功")
                this.getLists()
              })
            }).catch(() => {});
            break;
          case 'end':
            this.showMeetingSumary(row.id)
            break;
        }
      },
      startCreate() {
        this.$router.push("/Meeting/Room/List")
      },
      // 当前页
      handleCurrentChange(val) {
        this.form.page = val - 1
        this.getLists()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        this.form.page = 0
        this.getLists()
      },
      // 分页筛选数据
      getPaginationData() {
        this.paginationData = this.filterData
      },
      // 获取列表
      getLists() {
        ajax.get('/conference/list', this.form, (res) => {
          this.loading = false

          this.filterData = this.listData = res.vo.list
          this.pageTotal = res.vo.size
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/meeting/list.vue